<template>
    <Teleport to="body">
        <div
            v-if="showed"
            :class="{'modal fade show': true}"
            :style="{'display': 'block', 'z-index': zIndexModal, 'overflow-y' : 'scroll'}"
            @scroll="emitter.emit('modal-scroll')"
        >
            <div :class="['modal-dialog', size !== '' ? `modal-${size}` : '']">
                <div class="modal-content">
                    <div class="modal-header pb-3 bg-white">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button type="button" class="close" @click="hide">×</button>
                    </div>
                    <slot />
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="showed" :style="{'z-index': zIndexBackdrop}"></div>
    </Teleport>
</template>
<script>
export default {
    name: "AppModal",
    props: {
        size: {
            type: String,
            default: "", // xs, sm, lg, full
        },
        title: {
            type: String,
            required: true
        }
    },
    emits: ['onHide'],
    data() {
        return {
            scrollbar: null,
            showed: false,
            modalCount: 0,
            zIndexModal: 1015,
            zIndexBackdrop: 1010
        };
    },
    methods: {
        show() {
            if (this.showed === true) {
                return;
            }

            this.modalCount = document.getElementsByClassName('modal-backdrop').length
            this.zIndexBackdrop = 1000 + ((this.modalCount + 1) * 10)
            this.zIndexModal = this.zIndexBackdrop + 5

            this.showed = true;
        },
        hide() {
            if (this.showed === false) {
                return;
            }

            this.showed = false;
            this.$emit('onHide')
        },
        lockBodyScroll() {
            document.body.classList.add('modal-open');
            document.body.style.paddingRight = '15px';
        },
        unlockBodyScroll() {
            document.body.classList.remove('modal-open');
            document.body.style.paddingRight = '0';
        },
        isLastOpenedModal() {
            return document.getElementsByClassName('modal-backdrop').length === 1;
        }
    },
    watch: {
        showed(newVal) {
            if (newVal && document.getElementsByClassName('modal-backdrop').length === 0) {
                this.lockBodyScroll();
            } else if (!newVal && this.isLastOpenedModal()) {
                this.unlockBodyScroll();
            }
        }
    },
    beforeUnmount() {
        if (this.showed && this.isLastOpenedModal()) {
            this.unlockBodyScroll();
        }
    }
}
</script>
